import { useEffect } from "react";
import { Link } from "react-router-dom";

// T64: shared "Nothing available right now" page for an empty category or brand (direct URL / old links), always noindex.
export function NothingNow({ what, name, testid }) {
  useEffect(() => {
    let m = document.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement("meta"); m.name = "robots"; document.head.appendChild(m); }
    m.content = "noindex,follow";
  }, []);
  return (
    <div className="py-20 text-center" data-testid={testid}>
      <h1 className="rs-h1 text-[var(--brand-primary)]">Nothing available right now</h1>
      <p className="mx-auto mt-3 max-w-md text-slate-500">{name ? `We don't have ${what === "brand" ? `${name} products` : `anything in ${name}`} for sale at the moment.` : `This ${what} has nothing for sale at the moment.`} Stock changes often, so check back soon.</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link to="/products" className="rounded-full bg-[var(--brand-primary)] px-5 py-2.5 text-sm font-bold text-white" data-testid={`${testid}-products`}>All products</Link>
        <Link to="/brands" className="rounded-full border border-slate-300 px-5 py-2.5 text-sm font-bold text-slate-700" data-testid={`${testid}-brands`}>Browse brands</Link>
        <Link to="/ex-demo-clearance" className="rounded-full border border-slate-300 px-5 py-2.5 text-sm font-bold text-slate-700" data-testid={`${testid}-clearance`}>Ex-Demo &amp; Clearance</Link>
      </div>
    </div>
  );
}
